import * as mutations from './../../mutation-types'

export const processChecklist = (store, item) => {
    item.status = Boolean(item.status)
    store.commit(mutations.ADD_OR_UPDATE_CHECKLIST, item)
}

export const createChecklist = (store, item) => {
    return axios.post(`/api/checklists`, item)
        .then(res => {
            processChecklist(store, res.data.data)
            return res
        })
}

export const updateChecklist = (store, item) => {
    return axios.patch(`/api/checklists/${item.id}`, item)
        .then(res => {
            processChecklist(store, res.data.data)
            return res
        })
}

export const removeChecklist = (store, item) => {
    return axios.delete(`/api/checklists/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_CHECKLIST, item)
            return res
        })
}

export const fetchChecklists = (store, params) => {
    return axios.get(`/api/checklists`, { params })
        .then(res => {
            _.each(res.data.data, item => processChecklist(store, item))
            return res
        })
}